var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(90 4 4)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(180 9 4)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "translate(0 10)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(90 -4 12)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(135 6.93 4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(-135 11.07 4)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(45 -3.07 4.001)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__a",
    fill: "#FFC91D",
    transform: "rotate(135 -1.073 7.313)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5896 -520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Sun_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__b",
    fill: "#fff",
    transform: "translate(5899 523)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Sun_svg__c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Sun_svg__d",
    fill: "#FFC91D",
    transform: "translate(5899 523)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Sun_svg__a",
    d: "M0 0h2v-2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sun_svg__b",
    d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sun_svg__d",
    d: "M10 6a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8zm-4 4a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8zM2 6a4 4 0 0 1 4-4v-4a8 8 0 0 0-8 8zm4-4a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8z"
  }))));
};
export default SvgSun;